import type { ICrashlyticsService } from '@breath-lab/services';

export class WebCrashlyticsService implements ICrashlyticsService {
  recordError(_error: Error, _jsErrorContext?: Record<string, string>): void {}
  async setUserId(_userId: string): Promise<void> {}
  async setAttribute(_name: string, _value: string): Promise<void> {}
  log(_message: string): void {}
}
